import Image from '@components/Image';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import useAppCustom from '@hooks/useAppCustom';
import { ItemRow } from '@models/item';
import { useTranslation } from 'react-i18next';

interface Props {
    item: ItemRow;
}

function ItemImage({ item }:Props) {
    const { itemImageShape } = useAppCustom().items;
    const { thumbnailUrl, isSoldOut } = item;
    const { t } = useTranslation('items');
    return (
        <Container shape={itemImageShape}>
            <ThumbnailImage src={thumbnailUrl}
                width={120}
                height={120}
                isSoldOut={isSoldOut}
                alt={t('item.imageAlt')} />
            {isSoldOut && (
                <SoldOutBadge>
                    <Text fontWeight='medium' color={colors.textReverse}>
                        {t('item.soldOut')}
                    </Text>
                </SoldOutBadge>
            )}
        </Container>
    );
}

const Container = styled.div<{shape: 'RECTANGLE' | 'CIRCLE'}>`
    align-items: center;
    aspect-ratio: 1;
    border-radius: ${(props) => (props.shape === 'RECTANGLE' ? '12px' : '50%')};
    display: flex;
    justify-content: center;
    max-width: 100%;
    overflow: hidden;
    position: relative;
    width: 100%;
    transition: 200ms;
`;

const ThumbnailImage = styled(Image, {
    shouldForwardProp: (prop) => prop !== 'isSoldOut',
})<{isSoldOut?: boolean}>`
    filter: ${({ isSoldOut }) => (isSoldOut ? 'grayscale(1)' : 'none')};
    height: 100%;
    object-fit: cover;
    width: 100%;
`;

// 디자인의 딤(40%)·테두리(흰색 20%)에 맞는 토큰이 없어 값을 그대로 쓴다.
const SoldOutBadge = styled.div`
    align-items: center;
    background-color: rgba(0, 0, 0, 0.4);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: var(--radius-full);
    display: flex;
    height: var(--spacing-12);
    justify-content: center;
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    width: var(--spacing-12);
`;

export default ItemImage;
